import * as React from "react"
import { Label as LabelPrimitive } from "radix-ui"

import { cn } from "@/shadcn/lib/utils"

interface LabelProps extends React.ComponentProps<typeof LabelPrimitive.Root> {
  muted?: boolean
}

function Label({ className, muted, ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        muted && "text-muted-foreground",
        className
      )}
      {...props}
    />
  )
}

export { Label }
